const pages = {
  inst_page_title: 'المؤسسات الصحية',
  inst_page_subtitle: 'ابحث عن الأنسب بين {{count}} مؤسسة صحية في تركيا',
  inst_search_placeholder: 'البحث باسم المؤسسة أو الوصف...',
  inst_official_accreditation: 'الاعتماد الرسمي',
  inst_filters: 'التصفية',
  inst_branch: 'التخصص',
  inst_all_branches: 'جميع التخصصات',
  inst_branch_search: 'البحث عن تخصص...',
  inst_city: 'المدينة',
  inst_all_cities: 'جميع المدن',
  inst_city_search: 'البحث عن مدينة...',
  inst_sort: 'ترتيب',
  inst_sort_newest: 'الأحدث',
  inst_sort_name: 'بالاسم (أ-ي)',
  inst_sort_city: 'بالمدينة',
  inst_clear_filters: 'مسح جميع التصفيات',
  inst_results: 'تم العثور على {{count}} مؤسسة',
  inst_filtered_from: 'مصفاة من {{total}} مؤسسة',
  inst_branch_active: 'تصفية التخصص نشطة',
  inst_remove: 'إزالة',
  inst_loading: 'جار تحميل المؤسسات...',
  inst_no_results_title: 'لا توجد نتائج',
  inst_no_results_desc: 'حاول تغيير معايير البحث.',
  inst_no_results_branch: 'لم يتم العثور على مؤسسة بتخصص "{{branch}}".',
  inst_clear_filters_btn: 'مسح التصفيات',
  inst_expert_doctors: '{{count}} طبيب متخصص',
  inst_view_details: 'عرض التفاصيل',
  inst_consultation_available: 'يمكن إرسال طلب استشارة',
  inst_active_service_filter: 'فلتر العلاج النشط',
  inst_no_branches: 'لم تُضف تخصصات بعد',
  inst_no_results_search: 'لا توجد نتائج',

  contact_title: 'اتصل بنا',
  contact_subtitle: 'تواصل معنا لأسئلتك واقتراحاتك أو طلبات الدعم',
  contact_form_title: 'تواصل معنا',
  contact_name: 'الاسم الكامل',
  contact_name_placeholder: 'اسمك الأول والأخير',
  contact_email: 'البريد الإلكتروني',
  contact_email_placeholder: 'example@email.com',
  contact_phone: 'الهاتف',
  contact_phone_placeholder: '+966 555 555 5555',
  contact_subject: 'الموضوع',
  contact_subject_placeholder: 'اختر الموضوع',
  contact_subject_general: 'معلومات عامة',
  contact_subject_institution: 'تسجيل مؤسسة',
  contact_subject_technical: 'دعم تقني',
  contact_subject_suggestion: 'اقتراح',
  contact_subject_complaint: 'شكوى',
  contact_message: 'رسالتك',
  contact_message_placeholder: 'اكتب رسالتك هنا... (الحد الأقصى 500 حرف)',
  contact_char_count: '{{count}}/500 حرف',
  contact_submit: 'إرسال الرسالة',
  contact_submitting: 'جار الإرسال...',
  contact_success: 'تم إرسال رسالتك بنجاح. سنرد عليك في أقرب وقت ممكن.',
  contact_error: 'حدث خطأ. يرجى المحاولة مرة أخرى لاحقاً.',
  contact_info_title: 'معلومات الاتصال',
  contact_email_label: 'البريد الإلكتروني',
  contact_address_label: 'العنوان',
  contact_required: '*',

  register_title: 'إنشاء حساب',
  register_subtitle: 'انضم إلى منصتنا واتخذ الخطوة الصحيحة في رحلتك الصحية',
  register_user_tab: 'تسجيل المستخدم',
  register_institution_tab: 'تسجيل المؤسسة',
  register_already_member: 'هل لديك حساب بالفعل؟',
  register_login: 'تسجيل الدخول',

  detail_back: 'رجوع',
  detail_approved: 'معتمد',
  detail_pro: 'عضو PRO',
  detail_request_consultation: 'طلب استشارة',
  detail_doctors: 'الأطباء',
  detail_services: 'الخدمات',
  detail_gallery: 'المعرض',
  detail_location: 'الموقع',
  detail_about: 'عن المؤسسة',
  detail_branches: 'التخصصات',
  detail_no_description: 'لا يوجد وصف متاح.',

  reg_gender: 'الجنس',
  reg_gender_male: 'ذكر',
  reg_gender_female: 'أنثى',
  reg_gender_other: 'أفضل عدم الإفصاح',
  reg_firstname: 'الاسم الأول',
  reg_firstname_placeholder: 'اسمك الأول',
  reg_lastname: 'اسم العائلة',
  reg_lastname_placeholder: 'اسم عائلتك',
  reg_email: 'البريد الإلكتروني',
  reg_email_placeholder: 'example@email.com',
  reg_phone: 'الهاتف',
  reg_country: 'الدولة',
  reg_city: 'المدينة',
  reg_password: 'كلمة المرور',
  reg_password_placeholder: '6 أحرف على الأقل',
  reg_password_min: '6 أحرف على الأقل',
  reg_password_confirm: 'تأكيد كلمة المرور',
  reg_password_confirm_placeholder: 'أعد إدخال كلمة المرور',
  reg_select_country: 'اختر الدولة',
  reg_select_country_first: 'اختر الدولة أولاً',
  reg_select_city: 'اختر المدينة',
  reg_search_country: 'ابحث عن دولة أو رمز...',
  reg_no_results: 'لا توجد نتائج',
  reg_contracts_title: 'الاتفاقيات والأذونات',
  reg_terms_label: 'شروط الاستخدام',
  reg_kvkk_label: 'نص إفصاح KVKK',
  reg_marketing_label: 'موافقة التسويق والتواصل',
  reg_read_accept: 'قرأت وأوافق.',
  reg_optional: 'اختياري',
  reg_submit: 'إنشاء حساب',
  reg_submitting: 'جار التسجيل...',
  reg_success_title: 'تم التسجيل بنجاح!',
  reg_success_desc: 'تم إنشاء حسابك بنجاح.',
  reg_success_login_hint: 'يمكنك الآن تسجيل الدخول.',
  reg_go_login: 'تسجيل الدخول',
  reg_last_updated: 'آخر تحديث',
  reg_contract_not_found: 'محتوى العقد غير موجود.',
  reg_contract_required: 'قبول هذا العقد إلزامي',
  reg_contract_optional: 'موافقة اختيارية',
  reg_close: 'إغلاق',
  reg_err_gender: 'اختيار الجنس مطلوب',
  reg_err_firstname: 'الاسم الأول مطلوب',
  reg_err_lastname: 'اسم العائلة مطلوب',
  reg_err_email: 'البريد الإلكتروني مطلوب',
  reg_err_email_invalid: 'أدخل عنوان بريد إلكتروني صحيح',
  reg_err_email_unavailable: 'لا يمكن استخدام هذا البريد الإلكتروني.',
  reg_err_phone: 'الهاتف مطلوب',
  reg_err_country: 'اختيار الدولة مطلوب',
  reg_err_city: 'اختيار المدينة مطلوب',
  reg_err_password: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
  reg_err_password_match: 'كلمتا المرور غير متطابقتين',
  reg_err_terms: 'يجب قبول شروط الاستخدام',
  reg_err_kvkk: 'يجب قبول نص إفصاح KVKK',
  reg_err_marketing: 'يجب قبول موافقة التسويق والتواصل',
  reg_err_already_registered: 'هذا البريد الإلكتروني مسجل بالفعل. يرجى تسجيل الدخول.',
  reg_err_generic: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  reg_err_unexpected: 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
  inst_reg_name: 'اسم المؤسسة',
  inst_reg_name_placeholder: 'أدخل اسم المؤسسة',
  inst_reg_type: 'نوع المؤسسة',
  inst_type_hospital: 'مستشفى',
  inst_type_clinic: 'عيادة',
  inst_type_practice: 'طبيب',
  inst_type_agency: 'وكالة سياحة صحية',
  inst_type_agency_page: 'وكالات السياحة الصحية',
  inst_type_health_page: 'المؤسسات الصحية',
  inst_audience_client: 'عملاء',
  inst_audience_patient: 'مرضى',
  inst_reg_address: 'عنوان المؤسسة',
  inst_reg_address_placeholder: 'الشارع، رقم المبنى...',
  inst_reg_website: 'الموقع الإلكتروني',
  inst_reg_contact_person: 'الشخص المسؤول',
  inst_reg_contact_person_placeholder: 'الاسم الكامل',
  inst_reg_phone: 'هاتف التواصل',
  inst_reg_phone_placeholder: 'رقم الهاتف',
  inst_reg_phone_tr_hint: 'صيغة تركيا: 0XXX XXX XX XX (11 رقم)',
  inst_reg_email: 'عنوان البريد الإلكتروني للمستخدم',
  inst_reg_email_notice: 'بعد النقر على إنشاء حساب، سيتم إرسال رابط تحقق إلى بريدك الإلكتروني.',
  inst_reg_submit: 'إنشاء حساب مؤسسة',
  inst_reg_submitting: 'جار الحفظ...',
  inst_reg_success_title: 'تم تسجيل المؤسسة بنجاح!',
  inst_reg_success_email: 'تم إرسال رابط التحقق إلى بريدك الإلكتروني.',
  inst_reg_success_verify: 'يرجى التحقق من بريدك الإلكتروني وتفعيل عضويتك.',
  inst_reg_success_live: 'مؤسستك الآن مباشرة!',
  inst_reg_success_desc: 'بعد التحقق من البريد الإلكتروني، يمكنك تسجيل الدخول إلى لوحة المؤسسة. تم نشر مؤسستك تلقائياً في صفحة {{page}}. أكمل ملفك الشخصي للوصول إلى المزيد من {{audience}}.',
  inst_reg_go_panel: 'الذهاب إلى لوحة المؤسسة',
  inst_reg_err_name: 'اسم المؤسسة مطلوب',
  inst_reg_err_type: 'اختيار نوع المؤسسة مطلوب',
  inst_reg_err_contact: 'اسم الشخص المسؤول مطلوب',
  inst_reg_err_phone_tr: 'أدخل رقم هاتف صحيح (مثال: 0555 123 45 67)',
  inst_reg_err_phone_tr_start: 'يجب أن يبدأ رقم الهاتف بـ 0',
  inst_reg_err_phone_generic: 'أدخل رقم هاتف صحيح',
  inst_reg_err_rate_limit: 'تم تجاوز حد إرسال البريد الإلكتروني. يرجى المحاولة بعد ساعة.',
  inst_reg_err_user_not_created: 'تعذر إنشاء المستخدم.',
  inst_reg_err_insert: 'تعذر إنشاء تسجيل المؤسسة. يرجى المحاولة مرة أخرى.',

  detail_loading: 'جار تحميل معلومات المؤسسة...',
  detail_not_found_title: 'المؤسسة غير موجودة',
  detail_not_found_desc: 'المؤسسة التي تبحث عنها غير موجودة أو ربما تمت إزالتها.',
  detail_not_found_btn: 'العودة إلى المؤسسات الصحية',
  detail_serving_since: 'في الخدمة منذ {{year}}',
  detail_expert_doctors: '{{count}} طبيب متخصص',
  detail_consultation_btn: 'إرسال طلب استشارة',
  detail_institution_info: 'معلومات المؤسسة',
  detail_experience: 'الخبرة',
  detail_experience_years: '{{count}} سنوات',
  detail_expert_staff: 'الكادر المتخصص',
  detail_doctor_count: '{{count}} أطباء',
  detail_service_count: 'الخدمات',
  detail_service_count_val: '{{count}} خدمات',
  detail_official_accreditation: 'الاعتماد الرسمي',
  detail_health_turkey: 'Health Türkiye',
  detail_health_turkey_desc: 'منصة السياحة الصحية',
  detail_ministry_health: 'وزارة الصحة في جمهورية تركيا',
  detail_ministry_health_desc: 'مؤسسة صحية معتمدة',
  detail_ministry_culture: 'وزارة الثقافة والسياحة في جمهورية تركيا',
  detail_ministry_culture_desc: 'شهادة ترخيص السياحة الصحية',
  pro_only_title: 'مطلوب عضوية Pro',
  pro_only_desc: 'لا يمكنك إرسال طلب استشارة إلى هذه المؤسسة.',
  pro_only_info: 'طلبات الاستشارة متاحة فقط لـ <strong>مؤسسات الأعضاء Pro</strong>.',
  pro_only_explore: 'استكشاف مؤسسات Pro',
  pro_only_close: 'إغلاق',
  tab_general: 'معلومات عامة',
  tab_branches: 'التخصصات',
  tab_certificates: 'الشهادات والتكنولوجيا',
  tab_doctors: 'الأطباء',
  tab_media: 'الوسائط والمعرض',
  tab_videoblog: 'الفيديوهات والمدونات',
  tab_ivf: 'شهادة السياحة الصحية',
  tab_about: 'عن المؤسسة',
  tab_founded_year: 'سنة التأسيس',
  tab_experience_years: '{{count}} سنوات من الخبرة',
  tab_working_hours: 'ساعات العمل',
  tab_closed: 'مغلق',
  tab_location: 'الموقع',
  tab_no_description: 'لم تُضف وصف المؤسسة بعد',
  tab_no_photo: 'لم تُضف صور بعد',
  tab_no_video_blog: 'لم يُضف محتوى فيديو أو مدونة',
  tab_no_cert: 'لم تُضف معلومات الشهادات',
  tab_no_device: 'لم تُضف معلومات الأجهزة التكنولوجية',
  tab_no_ivf: 'لم تُضف شهادة ترخيص السياحة الصحية بعد',
  tab_cert_title: 'الشهادات والأجهزة التكنولوجية',
  tab_cert_section: 'الشهادات',
  tab_cert_count: '{{count}} شهادات',
  tab_device_section: 'الأجهزة التكنولوجية',
  tab_device_count: '{{count}} أجهزة',
  tab_branches_title: 'التخصصات',
  tab_doctors_title: 'الكادر المتخصص',
  tab_doctor_count_label: '{{count}} أطباء',
  tab_all_branches: 'جميع التخصصات ({{count}} أطباء)',
  tab_branch_registered: '(تخصص مسجل)',
  tab_no_doctor_branch: 'لم يُعثر على طبيب في هذا التخصص',
  tab_view_cv: 'عرض السيرة الذاتية',
  tab_no_cv: 'لم تُضف معلومات السيرة الذاتية بعد.',
  tab_cv_file: 'ملف السيرة الذاتية',
  tab_cv_format: 'صيغة {{format}} — انقر للعرض',
  tab_open_new_tab: 'فتح في تبويب جديد',
  tab_cv_loading: 'جار تحضير الملف...',
  tab_cv_please_wait: 'يرجى الانتظار',
  tab_cv_error: 'تعذر تحميل الملف',
  tab_cv_error_desc: 'الملف غير متاح أو حدث خطأ في الاتصال.',
  tab_cv_view_new_tab: 'عرض في تبويب جديد',
  tab_close: 'إغلاق',
  tab_show_less: 'عرض أقل',
  tab_show_more: 'عرض {{count}} صور أخرى',
  tab_main_photo: 'الصورة الرئيسية',
  tab_gallery_photos: 'صور المعرض',
  tab_doc_photos: 'صور الوثائق',
  tab_videos: 'الفيديوهات',
  tab_video_count: '{{count}} فيديوهات',
  tab_blogs: 'مقالات المدونة',
  tab_blog_count: '{{count}} مقالات',
  tab_no_preview: 'لا توجد معاينة للفيديو',
  tab_filter_clear: 'مسح',
  tab_showing_doctors: 'يُعرض {{count}} أطباء',
  tab_media_title: 'الوسائط والمعرض',
  tab_videoblog_title: 'الفيديوهات والمدونات',
  tab_ivf_title: 'شهادة ترخيص السياحة الصحية',
  consult_phone_placeholder: '+966 555 555 5555',
  consult_loading: 'جار التحميل...',
  consult_login_required: 'تسجيل الدخول مطلوب',
  consult_login_desc: 'يجب تسجيل الدخول إلى حسابك لإرسال طلب استشارة.',
  consult_login_info: 'يرجى تسجيل الدخول أو إنشاء حساب جديد لإرسال طلب استشارة إلى <strong>{{name}}</strong>.',
  consult_login_btn: 'تسجيل الدخول',
  consult_register_btn: 'إنشاء حساب',
  consult_title: 'طلب استشارة',
  consult_info: 'هذا النموذج طلب استشارة وليس موعداً. ستتصل بك المؤسسة عند الموافقة.',
  consult_fullname: 'الاسم الكامل',
  consult_fullname_placeholder: 'اسمك الأول والأخير',
  consult_email: 'البريد الإلكتروني',
  consult_phone: 'الهاتف',
  consult_treatment: 'العلاج المطلوب',
  consult_treatment_placeholder: 'اختر العلاج',
  consult_treatment_other: 'أخرى',
  consult_message: 'رسالتك',
  consult_message_placeholder: 'اشرح باختصار الموضوع الذي تريد مناقشته... (الحد الأقصى 500 حرف)',
  consult_submit: 'إرسال طلب الاستشارة',
  consult_submitting: 'جار الإرسال...',
  consult_success_title: 'تم استلام الطلب!',
  consult_success_desc: 'تم إرسال طلب الاستشارة إلى المؤسسة.',
  consult_success_hint: 'ستتصل بك المؤسسة في أقرب وقت ممكن.',
  consult_close: 'إغلاق',
  consult_err_fullname: 'الاسم الكامل مطلوب',
  consult_err_email: 'البريد الإلكتروني مطلوب',
  consult_err_phone: 'الهاتف مطلوب',
  consult_err_subject: 'اختيار العلاج مطلوب',
  consult_err_message: 'الرسالة مطلوبة',
  consult_err_generic: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  consult_err_unexpected: 'حدث خطأ غير متوقع.',

  turkiye_hero_badge: 'دليل السفر',
  turkiye_hero_title: 'اكتشف تركيا',
  turkiye_hero_desc: 'تركيا، موطن قارتين وآلاف السنين من التاريخ والجمال الطبيعي الفريد، تقدم تجربة لا تُنسى لكل مسافر.',
  turkiye_sidebar_categories: 'الفئات',
  turkiye_sidebar_destinations: 'الوجهات',
  turkiye_cat_cities: 'المدن الكبرى',
  turkiye_cat_historical: 'تاريخي وأثري',
  turkiye_cat_summer: 'منتجعات صيفية',
  turkiye_cat_nature: 'الطبيعة والثقافة',
  turkiye_cat_practical: 'معلومات عملية',
  turkiye_practical_title: 'معلومات السفر العملية',
  turkiye_practical_desc: 'ما تحتاج معرفته قبل القدوم إلى تركيا',
  turkiye_best_time: 'أفضل وقت للزيارة',
  turkiye_travel_tip: 'نصيحة سفر',
  turkiye_highlights: 'أبرز المعالم والتجارب',
  turkiye_cta_title: 'السياحة الصحية في تركيا',
  turkiye_cta_desc: 'استفد من خدمات الرعاية الصحية العالمية أثناء استكشاف تركيا. تعرف على مؤسساتنا الصحية المعتمدة.',
  turkiye_cta_btn: 'استكشف المؤسسات الصحية',
  turkiye_prac_visa_title: 'التأشيرة والدخول',
  turkiye_prac_visa_1: 'نظام التأشيرة الإلكترونية متاح للعديد من الدول',
  turkiye_prac_visa_2: 'طلب التأشيرة الإلكترونية عبر evisa.gov.tr',
  turkiye_prac_visa_3: 'يجب أن يكون جواز السفر صالحاً لمدة 6 أشهر على الأقل',
  turkiye_prac_visa_4: 'بعض الدول يمكنها الدخول بدون تأشيرة',
  turkiye_prac_transport_title: 'المواصلات',
  turkiye_prac_transport_1: 'شبكة مترو وترام وعبّارات في إسطنبول',
  turkiye_prac_transport_2: 'خيارات الحافلات والطيران بين المدن',
  turkiye_prac_transport_3: 'سيارات الأجرة وتطبيقات النقل الذكي متاحة',
  turkiye_prac_transport_4: 'سفر حر بسيارة مستأجرة',
  turkiye_prac_time_title: 'أفضل وقت',
  turkiye_prac_time_1: 'أبريل–مايو: الربيع، طقس مثالي',
  turkiye_prac_time_2: 'يونيو–أغسطس: الصيف، موسم الشاطئ',
  turkiye_prac_time_3: 'سبتمبر–أكتوبر: الخريف، ازدحام أقل',
  turkiye_prac_time_4: 'الشتاء: مناسب لإسطنبول والمناطق الداخلية',
  turkiye_prac_health_title: 'الصحة',
  turkiye_prac_health_1: 'تمتلك تركيا بنية تحتية صحية متطورة',
  turkiye_prac_health_2: 'خدمة باللغة الإنجليزية متاحة في المستشفيات الخاصة',
  turkiye_prac_health_3: 'يُنصح بالتأمين الصحي للسفر',
  turkiye_prac_health_4: 'الصيدليات متوفرة بسهولة في كل مكان',
  turkiye_prac_money_title: 'المال والدفع',
  turkiye_prac_money_1: 'الليرة التركية (TL) هي العملة الرسمية',
  turkiye_prac_money_2: 'بطاقات الائتمان مقبولة على نطاق واسع',
  turkiye_prac_money_3: 'أجهزة الصراف الآلي متاحة في كل مكان',
  turkiye_prac_money_4: 'مكاتب الصرافة تقدم أسعاراً تنافسية',
  turkiye_prac_comm_title: 'التواصل',
  turkiye_prac_comm_1: 'شريحة SIM التركية بأسعار معقولة وسهلة الحصول',
  turkiye_prac_comm_2: 'Wi-Fi مجاني منتشر في المقاهي والفنادق',
  turkiye_prac_comm_3: 'الطوارئ: 112، الشرطة: 155، الإطفاء: 110',
  turkiye_prac_comm_4: 'خط مساعدة السياحة: 170',

  turkiye_fact_area: 'المساحة',
  turkiye_fact_population: 'السكان',
  turkiye_fact_climate: 'المناخ',
  turkiye_fact_language: 'اللغة',
  turkiye_fact_currency: 'العملة',
  turkiye_fact_timezone: 'المنطقة الزمنية',
  turkiye_fact_hub: 'مركز الطيران',
  turkiye_fact_continent: 'القارة',
  privacy_title: 'سياسة الخصوصية',
  terms_title: 'شروط الاستخدام',
  kvkk_title: 'نص إفصاح KVKK',
  not_found_title: 'الصفحة غير موجودة',
  not_found_desc: 'الصفحة التي تبحث عنها غير موجودة.',
  not_found_back: 'الذهاب إلى الرئيسية',
  legal_loading: 'جار التحميل...',
  legal_last_updated: 'آخر تحديث',
  legal_version: 'الإصدار',
  legal_contact_btn: 'تواصل معنا',
  legal_contact_desc: 'هل لديك أسئلة؟ تواصل معنا.',
  privacy_info_text: 'حماية بياناتك الشخصية هي أولويتنا القصوى. بياناتك مؤمنة بموجب قانون KVKK رقم 6698.',
  terms_info_text: 'باستخدام منصتنا، يُعتبر أنك قبلت الشروط التالية. يرجى قراءة هذه الشروط بعناية.',
  kvkk_law_badge: 'بموجب القانون رقم 6698',
  kvkk_info_title: 'حماية البيانات الشخصية',
  kvkk_info_text: 'بصفتنا Health Travel Türkiye، تُعدّ أمان وخصوصية بياناتك الشخصية أولويتنا القصوى بموجب قانون حماية البيانات الشخصية رقم 6698 ("KVKK").',
  kvkk_data_controller: 'مسؤول البيانات',
  kvkk_data_controller_desc: 'تقوم منصة Health Travel Türkiye بمعالجة بياناتك بصفتها مسؤول البيانات.',
  kvkk_data_security: 'أمان البيانات',
  kvkk_data_security_desc: 'بياناتك محمية بتشفير SSL/TLS وتدابير أمنية متقدمة.',
  kvkk_application_right: 'حق التقديم',
  kvkk_application_right_desc: 'يمكنك التواصل معنا لممارسة حقوقك بموجب KVKK.',
  kvkk_rights_title: 'حقوقك بموجب KVKK',
  kvkk_rights_subtitle: 'وفقاً للمادة 11 من القانون رقم 6698',
  kvkk_application_methods: 'طرق التقديم',
  kvkk_email_method: 'البريد الإلكتروني',
  kvkk_email_method_desc: 'أرسل طلبك عبر البريد الإلكتروني',
  kvkk_kep_method: 'عنوان KEP',
  kvkk_kep_method_desc: 'تقدم عبر البريد الإلكتروني المسجل',
  kvkk_written_method: 'طلب مكتوب',
  kvkk_written_method_desc: 'تقدم بعريضة موقعة بخط اليد',
  kvkk_written_method_note: 'بريد مسجل إلى عنوان الشركة',
  kvkk_response_note: 'سيتم الرد على طلباتك في غضون <strong>30 يوماً</strong> على الأكثر.',
  kvkk_related_privacy: 'سياسة الخصوصية',
  kvkk_related_privacy_desc: 'تعرف على كيفية حماية بياناتك',
  kvkk_related_terms: 'شروط الاستخدام',
  kvkk_related_terms_desc: 'مراجعة شروط استخدام المنصة',
  kvkk_cta_title: 'هل لديك أسئلة؟',
  kvkk_cta_desc: 'تواصل معنا لممارسة حقوقك بموجب KVKK أو للحصول على معلومات حول بياناتك الشخصية.',
  not_found_path_label: 'المسار المطلوب',

  // Turkiye Kulturu page
  kultur_hero_badge: 'دليل ثقافي',
  kultur_hero_title: 'الثقافة في تركيا',
  kultur_hero_desc: 'فهم الثقافة التركية سيجعل رحلتك أكثر ثراءً ومعنى. من آداب السلوك إلى المطبخ، ومن التقاليد إلى المهرجانات — كل شيء هنا.',
  kultur_sidebar_title: 'الدليل الثقافي',
  kultur_sidebar_subtitle: 'اختر موضوعاً',
  kultur_sec_etiquette: 'آداب السلوك والأخلاق',
  kultur_sec_etiquette_sub: 'قواعد الاحترام والتهذيب',
  kultur_sec_food: 'المطبخ التركي',
  kultur_sec_food_sub: 'النكهات وثقافة الطعام',
  kultur_sec_religion: 'الدين والتقاليد',
  kultur_sec_religion_sub: 'الإيمان والقيم التقليدية',
  kultur_sec_festivals: 'الأعياد والمهرجانات',
  kultur_sec_festivals_sub: 'الأيام الخاصة والاحتفالات',
  kultur_sec_hamam: 'الحمام التركي',
  kultur_sec_hamam_sub: 'تقليد التطهير التاريخي',
  kultur_sec_social: 'الحياة الاجتماعية',
  kultur_sec_social_sub: 'الحياة اليومية والعادات',
  kultur_sec_language: 'اللغة والتواصل',
  kultur_sec_language_sub: 'أساسيات التركية والتواصل',
  kultur_sec_shopping: 'ثقافة التسوق',
  kultur_sec_shopping_sub: 'المساومة والهدايا التذكارية',
  kultur_food_tips_title: 'نصائح ثقافة الطعام',
  kultur_ramadan_travel: 'السفر خلال رمضان',
  kultur_ramadan_desc: 'إذا كنت تزور تركيا خلال رمضان، كن مستعداً لبعض الاختلافات. قد يُعدّ الأكل أو الشرب أمام الصائمين خلال النهار أمراً غير محترم. ومع ذلك، تبقى المطاعم في المناطق السياحية مفتوحة خلال النهار. يخلق وقت الإفطار جواً خاصاً في المدن.',
  kultur_lang_intro: 'التركية هي اللغة الرسمية لتركيا. تُستخدم الإنجليزية على نطاق واسع في المناطق السياحية. ومع ذلك، فإن تعلم بعض الكلمات التركية سيساعدك على إقامة علاقة دافئة مع السكان المحليين.',
  kultur_lang_info_title: 'معلومات عن اللغة',
  kultur_cta_title: 'تعرف على تركيا بشكل أفضل',
  kultur_cta_desc: 'استكشف فرص السياحة الصحية في تركيا التي اكتشفت ثقافتها.',
  kultur_cta_explore: 'استكشف تركيا',
  kultur_cta_institutions: 'المؤسسات الصحية',

  // ── Turkiye Kulturu – Etiquette ──
  etq_shoes_title: 'خلع الأحذية', etq_shoes_tip: 'إلزامي', etq_shoes_tipcolor: 'rose',
  etq_shoes_desc: 'عند دخول المنازل التركية، يُتوقع منك خلع حذائك عند الباب. يقدم المضيف عادةً نعالاً. هذا دليل على الأهمية التي تُعطى للنظافة. حتى لو لم تُقدَّم نعال، فإن خلع حذائك هو التصرف الصحيح.',
  etq_greet_title: 'التحية', etq_greet_tip: 'ثقافي', etq_greet_tipcolor: 'amber',
  etq_greet_desc: 'المصافحة شائعة. بين الأصدقاء المقربين والعائلة، التقبيل على الخد (كلا الخدين) أمر طبيعي. إظهار الاحترام للكبار مهم جداً؛ تقبيل يد الكبير ووضعها على الجبهة هو تعبير عميق عن الاحترام.',
  etq_host_title: 'الضيافة', etq_host_tip: 'موصى به', etq_host_tipcolor: 'teal',
  etq_host_desc: 'الأتراك مشهورون عالمياً بضيافتهم. عند الدعوة إلى منزل، إحضار هدية صغيرة (شوكولاتة، زهور، حلويات) يُعدّ لفتة جميلة. سيصر المضيف على تقديم الطعام والشراب — قبول القليل بدلاً من الرفض يُعدّ أكثر أدباً.',
  etq_photo_title: 'التصوير', etq_photo_tip: 'تنبيه', etq_photo_tipcolor: 'rose',
  etq_photo_desc: 'اطلب الإذن دائماً قبل تصوير الأشخاص. هذه القاعدة مهمة بشكل خاص للمسنين والنساء والأشخاص في الأماكن الدينية. عند التصوير في المساجد، تجنب تأطير الأشخاص الذين يصلون.',
  etq_mosque_title: 'السلوك في المساجد', etq_mosque_tip: 'إلزامي', etq_mosque_tipcolor: 'rose',
  etq_mosque_desc: 'اخلع حذاءك عند دخول المساجد. يجب على النساء تغطية رؤوسهن وإبقاء الأكتاف والركبتين مغطاة. تجنب الزيارة خلال أوقات الصلاة. كن هادئاً ومحترماً. معظم المساجد توفر أوشحة وشالات مجانية للسياح.',
  etq_bargain_title: 'المساومة', etq_bargain_tip: 'نصيحة', etq_bargain_tipcolor: 'amber',
  etq_bargain_desc: 'المساومة أمر طبيعي ومتوقع في البازار الكبير وبعض الأسواق والمحلات الصغيرة. ومع ذلك، الأسعار ثابتة في المطاعم والسوبرماركت ومراكز التسوق. ابتسم وحافظ على موقف ودي عند المساومة.',
  etq_tea_title: 'ثقافة الشاي', etq_tea_tip: 'ثقافي', etq_tea_tipcolor: 'teal',
  etq_tea_desc: 'الشاي التركي (الشاي الأسود) في مركز الحياة الاجتماعية. تقديم الشاي في محل أو مكتب هو علامة على الاحترام والصداقة. قد يُعدّ الرفض قلة أدب. شرب الشاي من كوب زجاجي تقليدي؛ يُقدَّم السكر بشكل منفصل.',
  etq_tip_title: 'الإكرامية', etq_tip_tip: 'موصى به', etq_tip_tipcolor: 'amber',
  etq_tip_desc: 'ترك إكرامية 10–15% في المطاعم أمر شائع. تقريب الأجرة لسائقي التاكسي كافٍ. تُتوقع الإكرامية أيضاً لموظفي الفنادق وأصحاب صالونات الحلاقة والمرشدين السياحيين. يُفضَّل ترك الإكرامية نقداً.',
  etq_eye_title: 'التواصل البصري', etq_eye_tip: 'ثقافي', etq_eye_tipcolor: 'teal',
  etq_eye_desc: 'يُقدّر الأتراك التواصل البصري عند الحديث. تجنب التواصل البصري قد يُفسَّر على أنه قلة احترام أو عدم ثقة. من ناحية أخرى، التحديق الطويل في النساء الأجنبيات قد يسبب إزعاجاً.',
  etq_noise_title: 'الضوضاء والصوت', etq_noise_tip: 'تنبيه', etq_noise_tipcolor: 'rose',
  etq_noise_desc: 'تجنب التحدث بصوت عالٍ في الأماكن الدينية والمستشفيات والأحياء الهادئة. يُتوقع الاحترام خلال الأذان. تجنب الضوضاء التي تزعج الجيران في وقت متأخر من الليل.',

  // ── Turkiye Kulturu – Foods ──
  food_kebap_name: 'الكباب', food_kebap_cat: 'طبق رئيسي', food_kebap_color: 'rose',
  food_kebap_desc: 'رمز المطبخ التركي. بعشرات الأنواع منها أضنة وأورفة والدونر والشيش والإسكندر، يناسب كل ذوق. كباب أضنة مشهور بلحمه المفروم الحار، بينما كباب أورفة معروف بنسخته الأقل حدة.',
  food_kebap_tip: 'كباب أضنة المأكول في أضنة ألذ بكثير من ذلك في إسطنبول.',
  food_meze_name: 'المزة', food_meze_cat: 'مقبلات', food_meze_color: 'amber',
  food_meze_desc: 'أطباق صغيرة مثل ورق العنب المحشو بزيت الزيتون والحمص والجاجيك وبيوريه الباذنجان والتاراما والبلح البحري المحشو. المقبلات التي لا غنى عنها على المائدة التركية. ثقافة المزة غنية بشكل خاص على موائد الراكي.',
  food_meze_tip: 'في مطاعم الأسماك، يُحضَر اختيار المزة عادةً إلى الطاولة — اختر ما يعجبك.',
  food_baklava_name: 'البقلاوة', food_baklava_cat: 'حلوى', food_baklava_color: 'teal',
  food_baklava_desc: 'ملكة الحلويات التركية، محضرة بالفستق أو الجوز بين طبقات رقيقة من العجين، منقوعة في الشراب. بقلاوة غازي عنتاب حاصلة على مؤشر جغرافي وعالمية الشهرة. الكنافة والقطايف والسوتلاج أيضاً من الحلويات التي يجب تجربتها.',
  food_baklava_tip: 'تناول البقلاوة الطازجة في غازي عنتاب أو في محلات بقلاوة راسخة مثل غولوأوغلو.',
  food_kahve_name: 'القهوة التركية', food_kahve_cat: 'مشروب', food_kahve_color: 'rose',
  food_kahve_desc: 'القهوة التركية المدرجة في قائمة التراث الثقافي لليونسكو فريدة في العالم بتقنية تحضيرها الدقيقة وتقديمها الرغوي. تُقدَّم مع الراحة التركية. قراءة الطالع من ثفل القهوة في قاع الفنجان جزء من الثقافة أيضاً.',
  food_kahve_tip: 'بعد شرب القهوة التركية، يمكنك قلب الفنجان وطلب قراءة الطالع.',
  food_pide_name: 'البيدة واللحم بعجين', food_pide_cat: 'طعام الشارع', food_pide_color: 'amber',
  food_pide_desc: 'البيدة المعروفة أيضاً بالبيتزا التركية تُخبز في الفرن بحشوات متنوعة. اللحم بعجين يُحضَّر بحشوة اللحم المفروم على عجين رقيق، يُؤكل بعصر الليمون ولفه بالجرجير. كلاهما طعام شارع بأسعار معقولة ومشبع.',
  food_pide_tip: 'تناول اللحم بعجين بعصر الليمون ولفه بالجرجير — الطريقة التركية الكلاسيكية.',
  food_kahvalti_name: 'الإفطار التركي', food_kahvalti_cat: 'إفطار', food_kahvalti_color: 'teal',
  food_kahvalti_desc: 'الإفطار التركي الغني المكون من أنواع مختلفة من الجبن والزيتون والطماطم والخيار والعسل والقشطة والبيض والمربيات المتنوعة هو وليمة حقيقية. إفطار وان هو أشهر ثقافة إفطار في تركيا. يمكن أن يستمر لساعات مصحوباً بالشاي.',
  food_kahvalti_tip: 'جرب إفطار السيرمه في وان أو في حي قراقوي بإسطنبول.',
  food_balik_name: 'السمك والمأكولات البحرية', food_balik_cat: 'طبق رئيسي', food_balik_color: 'rose',
  food_balik_desc: 'في تركيا المحاطة بالبحار من ثلاث جهات، ثقافة السمك الطازج قوية جداً. الأنشوجة وقاروص البحر والدنيس والترتة والأخطبوط من أكثر الخيارات شعبية. تناول السمك على ضفاف البوسفور في إسطنبول تجربة في حد ذاتها.',
  food_balik_tip: 'اسأل عن موسم السمك — أنشوجة البحر الأسود ألذ ما تكون في الشتاء.',
  food_corba_name: 'الشوربة', food_corba_cat: 'مقبلات', food_corba_color: 'amber',
  food_corba_desc: 'شوربة العدس الأحمر وشوربة الكرشة وشوربة إيزوغيلين هي ركائز المطبخ التركي. تُستهلك في أي وقت من الإفطار حتى منتصف الليل. شوربة الكرشة تُفضَّل أيضاً في وقت متأخر من الليل كعلاج من الخمار.',
  food_corba_tip: 'اعصر الليمون على شوربة العدس وأضف رقائق الفلفل الأحمر — ستكون مثالية.',
  food_raki_name: 'الراكي وثقافة الشرب', food_raki_cat: 'مشروب', food_raki_color: 'teal',
  food_raki_desc: 'الراكي هو المشروب الوطني لتركيا. يصبح هذا المشروب المنكّه بالأنيس أبيض حليبياً عند خلطه بالماء، لذلك يُعرف أيضاً بـ"حليب الأسد". يُشرب مع موائد المزة والأسماك والمأكولات البحرية. يُرتشف على موائد طويلة وممتعة.',
  food_raki_tip: 'امزج الراكي بالماء البارد، أضف الثلج واشرب ببطء — لا تتسرع.',
  food_sokak_name: 'مأكولات الشارع', food_sokak_cat: 'طعام الشارع', food_sokak_color: 'rose',
  food_sokak_desc: 'السيميت (خبز الحلقة بالسمسم) والبلح البحري المحشو والكومبير (البطاطا المشوية) وساندويتش السمك والكوكوريتش والدونر هي أكثر مأكولات الشارع المحبوبة في تركيا. اكتشاف هذه النكهات في شوارع إسطنبول هو أحد أفضل الطرق للتعرف على المدينة.',
  food_sokak_tip: 'جرب ساندويتش السمك على جسر غلاطة، والكومبير في أورتاكوي — لا بد من تجربتهما.',

  // ── Turkiye Kulturu – Food Tips ──
  kultur_food_tip1: 'يتناول الأتراك العشاء متأخراً، عادةً بين 20:00–22:00.',
  kultur_food_tip2: 'يُشرب الشاي في كل مكان وفي كل وقت. من الإفطار حتى منتصف الليل.',
  kultur_food_tip3: 'الخبز لا غنى عنه على المائدة التركية، يُقدَّم مع كل وجبة تقريباً.',
  kultur_food_tip4: 'ثقافة الحلويات قوية جداً. البقلاوة والكنافة والسوتلاج لا بد من تجربتها.',
  kultur_food_tip5: 'الخيارات النباتية متاحة لكن الأطباق القائمة على اللحوم هي السائدة.',
  kultur_food_tip6: 'اللوكانتالار (المطاعم المحلية) بأسعار معقولة عموماً. قد تكون الأسعار أعلى في المناطق السياحية.',

  // ── Turkiye Kulturu – Traditions ──
  trad_islam_title: 'تأثير الإسلام',
  trad_islam_desc: 'رغم أن تركيا دولة علمانية، فإن غالبية السكان مسلمون. يُصام في رمضان، وصلاة الجمعة مهمة. الكحول قانوني لكن قد تكون هناك قيود في بعض المناطق المحافظة. يُسمع الأذان 5 مرات يومياً.',
  trad_family_title: 'القيم الأسرية',
  trad_family_desc: 'تحتل الأسرة أهمية محورية في الثقافة التركية. احترام الكبار والضيافة والتضامن من القيم الأساسية. التجمعات الأسرية الكبيرة وزيارات الأعياد جزء لا يتجزأ من الثقافة. العلاقات مع الجيران مهمة جداً أيضاً.',
  trad_nazar_title: 'حبة العين الزرقاء',
  trad_nazar_desc: 'تُستخدم حبة العين الزرقاء للحماية من العين. تُرى بشكل شائع في المنازل والسيارات وعربات الأطفال والمجوهرات. يُعتقد أن حبة العين المكسورة قد امتصت الشر. إنها هدية تذكارية شعبية للسياح.',
  trad_music_title: 'الموسيقى والرقص',
  trad_music_desc: 'الموسيقى الشعبية التركية والموسيقى الكلاسيكية التركية لهما تقليد غني. الرقصات الشعبية مثل الزيبك (بحر إيجه) والهورون (البحر الأسود) والهلاي (شرق الأناضول) تتفاوت من منطقة إلى أخرى. الموسيقى البوب التركية تكتسب أيضاً اعترافاً متزايداً في جميع أنحاء العالم.',
  trad_craft_title: 'الحرف اليدوية',
  trad_craft_desc: 'الشيني (إزنيق وكوتاهيا) ونسج السجاد وأعمال النحاس وفن الإيبرو وصياغة الفضة التلكاري أجزاء مهمة من الثقافة التركية. يمكن العثور على منتجات يدوية أصيلة في البازار الكبير والأسواق. احذر من المنتجات المزيفة.',
  trad_ramadan_title: 'تقليد رمضان',
  trad_ramadan_desc: 'يخلق شهر رمضان أجواءً خاصة في تركيا. موائد الإفطار وطبالو رمضان وأضواء فوانيس المساجد والفعاليات الخاصة برمضان تجعل هذا الشهر لا يُنسى. تبقى المطاعم في المناطق السياحية مفتوحة خلال النهار.',
  trad_sunnet_title: 'حفل الختان',
  trad_sunnet_desc: 'حفل الختان طقس مرور مهم في الثقافة التركية. يُحتفل به بمراسم كبيرة، يرتدي الطفل ملابس خاصة ويتلقى الهدايا. هذه الاحتفالات فعاليات اجتماعية مهمة للأسرة والمجتمع.',
  trad_kina_title: 'ليلة الحناء',
  trad_kina_desc: 'ليلة الحناء التي تُقام قبل الزفاف هي مراسم تقليدية يُوضع فيها الحناء على يدي العروس وقدميها. تجتمع النساء وتُغنَّى الأغاني الشعبية وتُذرف الدموع. الأعراس التركية كبيرة وصاخبة عموماً.',

  // ── Turkiye Kulturu – Festivals ──
  fest_seker_title: 'عيد الفطر (عيد السكر)', fest_seker_date: 'يتغير حسب التقويم الهجري', fest_seker_color: 'rose',
  fest_seker_desc: 'إجازة 3 أيام تلي شهر رمضان. تجتمع الأسر، تُقبَّل أيدي الكبار، يتلقى الأطفال مصروفاً وحلوى. تُؤدَّى صلاة العيد في الصباح الباكر. الزيارات وشراء الهدايا جوهر هذا العيد.',
  fest_kurban_title: 'عيد الأضحى', fest_kurban_date: 'يتغير حسب التقويم الهجري', fest_kurban_color: 'amber',
  fest_kurban_desc: 'أكبر عيد ديني لمدة 4 أيام. تُذبح الأضاحي ويُوزَّع اللحم على الفقراء. تجتمع الأسر وتُزار المقابر. خلال هذه الفترة تخلو المدن وتمتلئ المنتجعات. تجربة ثقافية مثيرة للاهتمام للسياح.',
  fest_cumhuriyet_title: 'يوم الجمهورية', fest_cumhuriyet_date: '29 أكتوبر', fest_cumhuriyet_color: 'teal',
  fest_cumhuriyet_desc: 'ذكرى إعلان الجمهورية التركية عام 1923. تُقام استعراضات وحفلات موسيقية واحتفالات في جميع المدن. تُزيَّن المباني والشوارع بالأعلام التركية. تُقام أكبر الاحتفالات في أنقرة.',
  fest_nevruz_title: 'نوروز', fest_nevruz_date: '21 مارس', fest_nevruz_color: 'emerald',
  fest_nevruz_desc: 'مهرجان ذو أصول وسط آسيوية يحتفل بقدوم الربيع. يُحتفل به بحماس خاصة من قبل المجتمعات الكردية والعلوية. تُشعَل النيران ويُقفز فوقها، وتُرتدى الملابس الملونة. تُقام احتفالات كبيرة في جنوب شرق الأناضول.',
  fest_lale_title: 'مهرجان التوليب', fest_lale_date: 'أبريل', fest_lale_color: 'rose',
  fest_lale_desc: 'في مهرجان التوليب الذي يُقام كل عام في أبريل بإسطنبول، تتزين حدائق المدينة وميادينها بألوان ملايين زهور التوليب. تحتضن غابة إميرغان وحديقة غولهانه أجمل حدائق التوليب.',
  fest_muzik_title: 'مهرجان إسطنبول الموسيقي', fest_muzik_date: 'يونيو', fest_muzik_color: 'amber',
  fest_muzik_desc: 'مهرجان موسيقى كلاسيكية دولي يُقام كل عام في يونيو. تُقام حفلات موسيقية لفنانين من الطراز العالمي في أماكن تاريخية — آيا صوفيا وقصر توبقابي وقلعة روملي. إنه أبرز حدث ثقافي في تركيا.',
  fest_film_title: 'مهرجان البرتقالة الذهبية السينمائي', fest_film_date: 'أكتوبر', fest_film_color: 'teal',
  fest_film_desc: 'أعرق مهرجان سينمائي في تركيا يُقام كل عام في أكتوبر بأنطاليا. تتنافس أفضل إنتاجات السينما التركية، وتتوافد الأسماء الشهيرة إلى أنطاليا. تكتسب المدينة أجواءً خاصة خلال هذه الفترة.',
  fest_gures_title: 'مصارعة قيرق بينار بالزيت', fest_gures_date: 'يونيو–يوليو', fest_gures_color: 'emerald',
  fest_gures_desc: 'أقدم منظمة رياضية في العالم، تُقام في أدرنة منذ أكثر من 650 عاماً. في هذا التقليد المدرج في قائمة اليونسكو، يدهن المصارعون أنفسهم بزيت الزيتون ويتصارعون. إنه أحد أكثر فعاليات الثقافة التركية أصالة وألواناً.',

  // ── Turkiye Kulturu – Social Tips ──
  social_time_title: 'مفهوم الوقت',
  social_time_desc: 'قد يكون الأتراك مرنين في ما يتعلق بالوقت. التأخر قليلاً في الدعوات يُعدّ أمراً طبيعياً. هناك مفهوم يُسمى "الوقت التركي" — الصبر مهم. ومع ذلك، كن دقيقاً في المواعيد الرسمية.',
  social_chat_title: 'ثقافة المحادثة',
  social_chat_desc: 'يحب الأتراك الدردشة. الأسرة والسفر والطعام وكرة القدم نقاط انطلاق آمنة. من الأفضل تجنب المواضيع السياسية. سؤال "كيف حالك؟" علامة على اهتمام حقيقي — لا تتجاوزه بسرعة.',
  social_dress_title: 'ثقافة اللباس',
  social_dress_desc: 'الملابس العصرية شائعة في المدن. اللباس المحتشم مطلوب عند زيارة الأماكن الدينية. البيكيني طبيعي على الشواطئ. يسود نمط لباس أكثر محافظة في شرق الأناضول.',
  social_env_title: 'الوعي البيئي',
  social_env_desc: 'الوعي البيئي يتزايد في تركيا. استخدام الأكياس البلاستيكية مدفوع. رمي القمامة في المناطق الطبيعية محظور. حاويات إعادة التدوير تنتشر في المدن الكبرى.',
  social_safety_title: 'الأمان',
  social_safety_desc: 'تركيا بلد آمن بشكل عام. احذر من النشالين في المناطق السياحية. اتصل بـ 112 في حالات الطوارئ. كن يقظاً تجاه محاولات الاحتيال التي تستهدف السياح الأجانب.',
  social_traffic_title: 'المرور والمواصلات',
  social_traffic_desc: 'قد يكون السائقون الأتراك عدوانيين. كن حذراً عند ممرات المشاة. استخدام وسائل النقل العام في المدن الكبرى أكثر عملية. يمكن أيضاً تفضيل تطبيقات أوبر أو بيتاكسي بدلاً من سيارات الأجرة.',
  social_internet_title: 'الإنترنت والتكنولوجيا',
  social_internet_desc: 'تركيا لديها بنية تحتية إنترنت متطورة. الواي فاي المجاني منتشر في المقاهي والفنادق. قد يكون الوصول إلى بعض منصات التواصل الاجتماعي مقيداً أحياناً. استخدام VPN شائع.',
  social_climate_title: 'المناخ واللباس',
  social_climate_desc: 'تُعاش مناخات مختلفة جداً في مناطق مختلفة من تركيا. البحر الأسود ممطر، والبحر الأبيض المتوسط حار وجاف، والأناضول الوسطى قارية. أعدّ ملابس مناسبة وفقاً لخطة سفرك.',

  // ── Turkiye Kulturu – Language Phrases ──
  lang_merhaba_tr: 'Merhaba', lang_merhaba_pron: 'Mer-ha-ba', lang_merhaba_mean: 'مرحباً / أهلاً', lang_merhaba_cat: 'أساسيات',
  lang_tesekkur_tr: 'Teşekkür ederim', lang_tesekkur_pron: 'Te-şek-kür e-de-rim', lang_tesekkur_mean: 'شكراً', lang_tesekkur_cat: 'أساسيات',
  lang_lutfen_tr: 'Lütfen', lang_lutfen_pron: 'Lüt-fen', lang_lutfen_mean: 'من فضلك', lang_lutfen_cat: 'أساسيات',
  lang_evet_tr: 'Evet / Hayır', lang_evet_pron: 'E-vet / Hay-ır', lang_evet_mean: 'نعم / لا', lang_evet_cat: 'أساسيات',
  lang_nekadar_tr: 'Ne kadar?', lang_nekadar_pron: 'Ne ka-dar?', lang_nekadar_mean: 'كم الثمن؟', lang_nekadar_cat: 'تسوق',
  lang_pahali_tr: 'Çok pahalı', lang_pahali_pron: 'Çok pa-ha-lı', lang_pahali_mean: 'غالٍ جداً', lang_pahali_cat: 'تسوق',
  lang_hesap_tr: 'Hesap lütfen', lang_hesap_pron: 'He-sap lüt-fen', lang_hesap_mean: 'الحساب من فضلك', lang_hesap_cat: 'مطعم',
  lang_guzel_tr: 'Çok güzel', lang_guzel_pron: 'Çok gü-zel', lang_guzel_mean: 'جميل جداً / رائع', lang_guzel_cat: 'عام',
  lang_nerede_tr: 'Nerede?', lang_nerede_pron: 'Ne-re-de?', lang_nerede_mean: 'أين؟', lang_nerede_cat: 'اتجاهات',
  lang_yardim_tr: 'Yardım edin!', lang_yardim_pron: 'Yar-dım e-din!', lang_yardim_mean: 'النجدة!', lang_yardim_cat: 'طوارئ',
  lang_afiyet_tr: 'Afiyet olsun', lang_afiyet_pron: 'A-fi-yet ol-sun', lang_afiyet_mean: 'بالهناء والشفاء', lang_afiyet_cat: 'مطعم',
  lang_gule_tr: 'Güle güle', lang_gule_pron: 'Gü-le gü-le', lang_gule_mean: 'مع السلامة', lang_gule_cat: 'أساسيات',
  lang_cat_basic: 'أساسيات', lang_cat_shopping: 'تسوق', lang_cat_restaurant: 'مطعم',
  lang_cat_general: 'عام', lang_cat_directions: 'اتجاهات', lang_cat_emergency: 'طوارئ',
  kultur_lang_tip1: 'الإنجليزية تُستخدم على نطاق واسع في المناطق السياحية.',
  kultur_lang_tip2: 'التركية مكتوبة بالأبجدية اللاتينية؛ النطق منتظم إلى حد ما.',
  kultur_lang_tip3: 'ترجمة جوجل تعمل جيداً للتركية؛ يمكن أيضاً استخدام ترجمة الكاميرا.',
  kultur_lang_tip4: 'قول بعض الكلمات التركية يسعد السكان المحليين كثيراً.',

  // ── Turkiye Kulturu – Shopping ──
  shop_kapali_title: 'البازار الكبير', shop_kapali_color: 'rose',
  shop_kapali_desc: 'أحد أكبر الأسواق المغطاة في العالم بإسطنبول بأكثر من 4000 محل. السجاد والمجوهرات والجلود والبهارات والهدايا التذكارية متاحة. المساومة متوقعة وممتعة.',
  shop_misir_title: 'البازار المصري', shop_misir_color: 'amber',
  shop_misir_desc: 'البازار المصري (سوق البهارات) في حي إمينونو بإسطنبول يقدم أجود البهارات والراحة التركية والمكسرات. مكان مثالي لشراء الشاي والقهوة والبهارات.',
  shop_hediye_title: 'الهدايا التذكارية', shop_hediye_color: 'teal',
  shop_hediye_desc: 'حبات العين الزرقاء والأطباق الخزفية والسجاد اليدوي وأطقم القهوة التركية ومنتجات النحاس وأعمال فن الإيبرو هي أكثر الهدايا التذكارية شعبية. احذر من المنتجات المزيفة؛ فضّل المحلات الراسخة للمنتجات عالية الجودة.',
  shop_deri_title: 'الجلود والمنسوجات', shop_deri_color: 'emerald',
  shop_deri_desc: 'تركيا معروفة عالمياً بمنتجات الجلود والمنسوجات. يمكن العثور على جاكيتات وحقائب وأحذية جلدية عالية الجودة بأسعار معقولة. أسواق الجلود في المدن الكبرى مثالية لهذا التسوق.',
  shop_cay_title: 'الشاي والقهوة', shop_cay_color: 'rose',
  shop_cay_desc: 'الشاي التركي والقهوة التركية من أفضل الهدايا التذكارية. يمكن تفضيل شاي ريزه للشاي وماركة كوروكاهفيجي محمد أفندي للقهوة. أطقم ذات تغليف جميل متاحة في الأسواق.',
  shop_dikkat_title: 'أمور يجب الانتباه إليها', shop_dikkat_color: 'amber',
  shop_dikkat_desc: 'احذر من المنتجات المزيفة. كن حذراً من دعوات بائعي السجاد الملحّة. لا تشتر منتجاً دون معرفة سعره. قد تُطلب رسوم إضافية للدفع ببطاقة الائتمان — اسأل مسبقاً.',

  // ── Turkiye Kulturu – Hamam ──
  hamam_title: 'تجربة الحمام التركي',
  hamam_subtitle: 'تقليد عريق للتطهير والتواصل الاجتماعي',
  hamam_intro: 'الحمام التركي تقليد عريق للتطهير والتواصل الاجتماعي. هذه التجربة التي تُجرى بالكيس (التقشير) والتدليك بالرغوة على الرخام الساخن من الأنشطة الثقافية التي يجب تجربتها في تركيا. يمكن العثور على حمامات تاريخية من الحقبة العثمانية في إسطنبول وبورصة وأدرنة.',
  hamam_wear_title: 'ماذا ترتدي؟',
  hamam_wear_desc: 'يُقدَّم بيشتمال (منشفة) وناليين (قبقاب خشبي). لا حاجة لإحضار منشفتك الخاصة.',
  hamam_gender_title: 'الرجال والنساء',
  hamam_gender_desc: 'أقسام الرجال والنساء منفصلة. يمكن العثور على حمامات مختلطة في المناطق السياحية.',
  hamam_kese_title: 'الكيس والتدليك',
  hamam_kese_desc: 'يُجرى تنظيف الجلد بالكيس والتدليك بالرغوة. يمكن الحصول على تدليك بالزيت مقابل رسوم إضافية.',
  hamam_tourist_title: 'الحمامات السياحية',
  hamam_tourist_desc: 'الحمامات السياحية تقدم خدمة باللغة الإنجليزية. الأسعار تتراوح بين 30–150 يورو.',
  hamam_duration_title: 'كم يستغرق؟',
  hamam_duration_desc: 'تجربة الحمام الأساسية تستغرق 45–60 دقيقة. مع إضافة التدليك يمكن أن تمتد إلى 90 دقيقة.',
  hamam_best_title: 'أفضل الحمامات',
  hamam_best_desc: 'في إسطنبول، حمامات تشمبرلي طاش وجاغالوغلو وسليمانية تاريخية وشهيرة.',
  kultur_ramadan_item1: 'المطاعم والمقاهي السياحية تبقى مفتوحة خلال النهار',
  kultur_ramadan_item2: 'وقت الإفطار (أذان المغرب) يخلق أجواءً خاصة',
  kultur_ramadan_item3: 'طبالو رمضان يوقظون الناس في الساعة 3–4 صباحاً',

  // Araci Kurumlar page
  araci_hero_badge: 'خدمات التنظيم والسفر',
  araci_hero_title: 'وكالات السياحة الصحية',
  araci_hero_desc: 'إذا كنت تريد تنظيم خدمتك الصحية مع احتياجات السفر والإقامة والسياحة، يمكنك تصفح وكالات السياحة الصحية لدينا.',
  araci_hero_desc_strong: 'السفر والإقامة والسياحة',
  araci_feature_flight: 'الطيران والنقل',
  araci_feature_hotel: 'حجز الفندق',
  araci_feature_tour: 'جولة سياحية',
  araci_feature_translation: 'الترجمة',
  araci_feature_vip: 'استقبال VIP',
  araci_search_placeholder: 'البحث باسم الوكالة أو الوصف...',
  araci_all_cities: 'جميع المدن',
  araci_services_title: 'الخدمات المقدمة',
  araci_svc_flight: 'الطيران والنقل',
  araci_svc_flight_desc: 'الاستقبال في المطار والنقل',
  araci_svc_hotel: 'الإقامة',
  araci_svc_hotel_desc: 'حجز الفنادق والشقق',
  araci_svc_tour: 'جولة سياحية',
  araci_svc_tour_desc: 'جولة المدينة وتنظيم الرحلات',
  araci_svc_translation: 'الترجمة',
  araci_svc_translation_desc: 'دعم اللغة والإرشاد',
  araci_results: 'تم العثور على <strong>{{count}}</strong> وكالة سياحة صحية',
  araci_sort_label: 'ترتيب:',
  araci_sort_newest: 'الأحدث',
  araci_sort_name: 'بالاسم',
  araci_sort_city: 'بالمدينة',
  araci_clear_filters: 'مسح التصفيات',
  araci_loading: 'جار تحميل وكالات السياحة الصحية...',
  araci_type_badge: 'وكالة سياحة صحية',
  araci_view_details: 'عرض التفاصيل',
  araci_pro_consult: 'يمكن إرسال طلب استشارة',
  araci_empty_title_filter: 'لا توجد نتائج',
  araci_empty_title_none: 'لا توجد وكالات سياحة صحية بعد',
  araci_empty_desc_filter: 'حاول تغيير معايير البحث.',
  araci_empty_desc_none: 'ستُدرج وكالات السياحة الصحية قريباً. يرجى الزيارة لاحقاً.',
  araci_default_desc: 'خدمات تنظيم السياحة الصحية',

  // ── Turkiye Hakkinda Destinations ──
  dest_istanbul_name: 'إسطنبول', dest_istanbul_region: 'مرمرة',
  dest_istanbul_tagline: 'حيث يلتقي القارتان',
  dest_istanbul_desc: 'إسطنبول التي تربط آسيا وأوروبا، هي إحدى أكثر المدن سحراً في العالم بتاريخها الممتد 2500 عام.',
  dest_istanbul_longdesc: 'هذه المدينة الفريدة التي تمزج الإرث العثماني والبيزنطي مع الحياة العصرية تقدم اكتشافاً جديداً في كل زاوية. تحتضن إسطنبول عوالم متعددة في مدينة واحدة — شبه الجزيرة التاريخية، وضفاف مضيق البوسفور، وأجواء منطقة بيوغلو الكوزموبوليتانية، والأحياء الهادئة في الأناضول. في إسطنبول، المدينة العابرة للقارتين الوحيدة في العالم، تنتظركم المساجد التاريخية والقصور والأسواق والمتاحف.',
  dest_istanbul_h1_name: 'آيا صوفيا', dest_istanbul_h1_desc: 'مبنى عمره 1500 عام من بيزنطة إلى الحقبة العثمانية، يُعدّ الأعجوبة الثامنة في العالم',
  dest_istanbul_h2_name: 'قصر توبقابي', dest_istanbul_h2_desc: 'مركز الإمبراطورية العثمانية لـ 400 عام، مع خزينته وحريمه',
  dest_istanbul_h3_name: 'البازار الكبير', dest_istanbul_h3_desc: 'أحد أكبر الأسواق المغطاة في العالم بأكثر من 4000 محل، مفتوح منذ 1461',
  dest_istanbul_h4_name: 'جولة البوسفور', dest_istanbul_h4_desc: 'جولة بحرية فريدة يمكنك فيها مشاهدة القارتين معاً',
  dest_istanbul_h5_name: 'برج غلاطة', dest_istanbul_h5_desc: 'برج جنوي من القرن الـ14 يوفر مناظر بانورامية للمدينة',
  dest_istanbul_h6_name: 'السلطانأحمد', dest_istanbul_h6_desc: 'قلب شبه الجزيرة التاريخية — الجامع الأزرق، الميدان، الخزان البازيليكي',
  dest_istanbul_h7_name: 'بيوغلو وشارع الاستقلال', dest_istanbul_h7_desc: 'غاليريات فنية، مقاهٍ، أروقة تاريخية وحياة ليلية نابضة',
  dest_istanbul_h8_name: 'ساندويتش السمك والسيميت', dest_istanbul_h8_desc: 'ساندويتش السمك على جسر غلاطة، الشاي على البوسفور — نكهات إسطنبول',
  dest_istanbul_tag1: 'تاريخ', dest_istanbul_tag2: 'ثقافة', dest_istanbul_tag3: 'تسوق', dest_istanbul_tag4: 'طعام', dest_istanbul_tag5: 'البوسفور',
  dest_istanbul_besttime: 'أبريل–يونيو & سبتمبر–نوفمبر',
  dest_istanbul_tip: 'احصل على بطاقة إسطنبول لاستخدام المترو والترام والعبّارة ببطاقة واحدة.',
  dest_izmir_name: 'إزمير', dest_izmir_region: 'بحر إيجه',
  dest_izmir_tagline: 'لؤلؤة بحر إيجه',
  dest_izmir_desc: 'ثالث أكبر مدن تركيا إزمير تتميز بطابعها الكوزموبوليتاني على ساحل بحر إيجه وأسلوب حياتها المنفتح.',
  dest_izmir_longdesc: 'هذه المدينة الممتدة من آثار أفسوس القديمة إلى واجهة كوردون الحديثة تقدم التاريخ والطبيعة في توازن مثالي. مع سوق كيميرألتي التاريخي وملاهي كوردون المطلة على البحر والمدن القديمة المجاورة، تُعدّ إزمير وجهة مثالية لمن يبحثون عن التاريخ والحياة العصرية معاً.',
  dest_izmir_h1_name: 'مدينة أفسوس الأثرية', dest_izmir_h1_desc: 'إحدى أفضل المدن القديمة المحفوظة في العالم، بالقرب من معبد أرتميس',
  dest_izmir_h2_name: 'برج الساعة', dest_izmir_h2_desc: 'رمز ميدان كوناك، برج تاريخي بني عام 1901',
  dest_izmir_h3_name: 'كوردون', dest_izmir_h3_desc: 'ممشى ومسار دراجات مطل على بحر إيجه، مع مقاهٍ ومطاعم',
  dest_izmir_h4_name: 'سوق كيميرألتي', dest_izmir_h4_desc: 'سوق تاريخي بالبهارات والصباغين والمأكولات المحلية',
  dest_izmir_h5_name: 'تشيشمه', dest_izmir_h5_desc: 'منتجع بحري مشهور بمياهه الصافية والتزلج على الأمواج والغوص',
  dest_izmir_h6_name: 'برغامة (بيرغامون)', dest_izmir_h6_desc: 'مدينة بيرغامون القديمة، الأكروبول الشهير ومركز أسكليبيون الصحي',
  dest_izmir_tag1: 'مدينة أثرية', dest_izmir_tag2: 'بحر إيجه', dest_izmir_tag3: 'بحر', dest_izmir_tag4: 'طعام', dest_izmir_tag5: 'تاريخ',
  dest_izmir_besttime: 'أبريل–يونيو & سبتمبر–أكتوبر',
  dest_izmir_tip: 'زُر أفسوس في الصباح الباكر — يصبح مكتظاً بعد الظهر.',
  dest_antalya_name: 'أنطاليا', dest_antalya_region: 'البحر الأبيض المتوسط',
  dest_antalya_tagline: 'عاصمة السياحة التركية',
  dest_antalya_desc: 'حيث تلتقي المياه الزرقاء للبحر الأبيض المتوسط بالجبال الخضراء لجبال طوروس، تستقبل أنطاليا أكثر من 15 مليون سائح سنوياً.',
  dest_antalya_longdesc: 'أنطاليا بمدنها القديمة وشواطئها الرائعة ومنتجعاتها الفاخرة التي تناسب كل الأذواق، هي الوجهة السياحية الأكثر شعبية في تركيا. تقدم الأسوار الرومانية لمدينة كالييتشي وشلال دودن المتدفق في البحر والمدن القديمة المحيطة التاريخ والطبيعة معاً.',
  dest_antalya_h1_name: 'كالييتشي', dest_antalya_h1_desc: 'مركز المدينة التاريخي محاط بأسوار رومانية، فنادق بوتيك ومقاهٍ',
  dest_antalya_h2_name: 'شلال دودن', dest_antalya_h2_desc: 'شلال فريد يتدفق في البحر، يمكن مشاهدته بجولة بحرية',
  dest_antalya_h3_name: 'شاطئ كونياألتي', dest_antalya_h3_desc: 'شاطئ حصى طويل قريب من مركز المدينة، حاصل على الراية الزرقاء',
  dest_antalya_h4_name: 'أسبيندوس', dest_antalya_h4_desc: 'أفضل مسرح روماني محفوظ في العالم، لا يزال يستضيف حفلات',
  dest_antalya_h5_name: 'كاش وكالكان', dest_antalya_h5_desc: 'منتجعات بوتيك، غوص، جولات بحرية ورحلات الشاطئ الأزرق',
  dest_antalya_h6_name: 'بوابة هادريان', dest_antalya_h6_desc: 'قوس نصر روماني من عام 130 م، عند مدخل كالييتشي',
  dest_antalya_tag1: 'شاطئ', dest_antalya_tag2: 'تاريخ', dest_antalya_tag3: 'فاخر', dest_antalya_tag4: 'مدينة أثرية', dest_antalya_tag5: 'البحر الأبيض المتوسط',
  dest_antalya_besttime: 'أبريل–نوفمبر (يونيو–سبتمبر للصيف)',
  dest_antalya_tip: 'أقِم ليلة في كالييتشي — النوم في التاريخ تجربة لا تُنسى.',
  dest_gobeklitepe_name: 'غوبكلي تبه', dest_gobeklitepe_region: 'جنوب شرق الأناضول',
  dest_gobeklitepe_tagline: 'أقدم معبد في العالم',
  dest_gobeklitepe_desc: 'غوبكلي تبه الذي يعود تاريخه إلى 10000 قبل الميلاد هو معجزة أثرية أعادت كتابة التاريخ البشري.',
  dest_gobeklitepe_longdesc: 'يقع غوبكلي تبه بالقرب من شانلي أورفا وهو أقدم مجمع معابد معروف في العالم، أقدم من ستونهنج بـ 6000 عام. تكشف نقوش الحيوانات على الأعمدة الضخمة على شكل حرف T مدى تطور الحضارة الإنسانية في عصور ما قبل التاريخ. هذا الموقع المدرج في قائمة التراث العالمي لليونسكو هو اكتشاف ثوري في عالم الآثار.',
  dest_gobeklitepe_h1_name: 'الأعمدة على شكل T', dest_gobeklitepe_h1_desc: 'أعمدة حجر جيري ضخمة من 10000 قبل الميلاد بنقوش حيوانية',
  dest_gobeklitepe_h2_name: 'متحف شانلي أورفا', dest_gobeklitepe_h2_desc: 'أحد أكبر متاحف الآثار في العالم، موطن تمثال إنسان أورفا',
  dest_gobeklitepe_h3_name: 'قره حان تبه', dest_gobeklitepe_h3_desc: 'الموقع الشقيق لغوبكلي تبه، يُكشف من خلال حفريات جديدة',
  dest_gobeklitepe_h4_name: 'نفق تيتوس', dest_gobeklitepe_h4_desc: 'قناة مياه ضخمة من الحقبة الرومانية، بالقرب من سامانداغ',
  dest_gobeklitepe_tag1: 'آثار', dest_gobeklitepe_tag2: 'يونسكو', dest_gobeklitepe_tag3: 'عصر ما قبل التاريخ', dest_gobeklitepe_tag4: 'شانلي أورفا',
  dest_gobeklitepe_besttime: 'أكتوبر–أبريل (حار جداً في الصيف)',
  dest_gobeklitepe_tip: 'احجز جولة مرشدة من شانلي أورفا — المرشد ضروري لفهم السياق التاريخي.',
  dest_senpiyer_name: 'كنيسة القديس بطرس', dest_senpiyer_region: 'جنوب شرق الأناضول',
  dest_senpiyer_tagline: 'أول كنيسة في العالم',
  dest_senpiyer_desc: 'كنيسة القديس بطرس في أنطاكيا هي كنيسة كهفية تاريخية تُعدّ المكان الذي أسسه القديس بطرس وأول مكان عبادة مسيحي.',
  dest_senpiyer_longdesc: 'تقع هذه الكنيسة الكهفية عند سفح جبل حبيبي نجار في منطقة أنطاكيا بهاتاي، وتعود إلى القرن الأول الميلادي. يُقال إن القديس بطرس كان يعظ في هذا الموقع المقدس وكان المسيحيون الأوائل يتعبدون سراً. وأنطاكيا هي أيضاً المدينة التي استُخدمت فيها كلمة "مسيحي" لأول مرة. الفسيفساء في متحف أنطاكيا الأثري المجاور عالمية الشهرة.',
  dest_senpiyer_h1_name: 'الكنيسة الكهفية', dest_senpiyer_h1_desc: 'من القرن الأول الميلادي، أول مكان عبادة مسيحي في العالم',
  dest_senpiyer_h2_name: 'فسيفساء أنطاكيا', dest_senpiyer_h2_desc: 'إحدى أكبر مجموعات الفسيفساء في العالم، في متحف هاتاي',
  dest_senpiyer_h3_name: 'سوق أنطاكيا', dest_senpiyer_h3_desc: 'سوق تاريخي، مأكولات فريدة من مطبخ هاتاي',
  dest_senpiyer_h4_name: 'نفق تيتوس', dest_senpiyer_h4_desc: 'قناة مياه ضخمة من الحقبة الرومانية',
  dest_senpiyer_tag1: 'مسيحية', dest_senpiyer_tag2: 'تاريخ', dest_senpiyer_tag3: 'هاتاي', dest_senpiyer_tag4: 'أنطاكيا', dest_senpiyer_tag5: 'موقع مقدس',
  dest_senpiyer_besttime: 'مارس–مايو & سبتمبر–نوفمبر',
  dest_senpiyer_tip: 'في أنطاكيا، لا تفوّت تذوق الكنافة والحمص — مطبخ هاتاي من أغنى المطابخ في تركيا.',
  dest_efes_name: 'مدينة أفسوس الأثرية', dest_efes_region: 'بحر إيجه',
  dest_efes_tagline: 'عاصمة العالم القديم',
  dest_efes_desc: 'إحدى أفضل المدن القديمة المحفوظة في العالم، أفسوس تحمل عظمة الحقبة الرومانية حتى يومنا هذا.',
  dest_efes_longdesc: 'تقع أفسوس على بعد 80 كم من إزمير وهي مدينة أثرية شاسعة تأسست في القرن العاشر قبل الميلاد وكانت عاصمة المقاطعة الرومانية لآسيا. مكتبة سيلسوس والمسرح الكبير وشارع الرخام وأطلال معبد أرتميس جعلت أفسوس إحدى أهم مدن العالم القديم. هذا الموقع المدرج في التراث العالمي لليونسكو يستقبل أكثر من مليوني زائر سنوياً.',
  dest_efes_h1_name: 'مكتبة سيلسوس', dest_efes_h1_desc: 'إحدى أكبر مكتبات العالم القديم، بواجهتها الرخامية الرائعة',
  dest_efes_h2_name: 'المسرح الكبير', dest_efes_h2_desc: 'مسرح روماني ضخم لـ 25000 شخص، لا يزال يستضيف فعاليات',
  dest_efes_h3_name: 'بيت العذراء مريم', dest_efes_h3_desc: 'الموقع المقدس الذي يُعتقد أن العذراء مريم أمضت فيه سنواتها الأخيرة',
  dest_efes_h4_name: 'معبد أرتميس', dest_efes_h4_desc: 'إحدى عجائب الدنيا السبع، عمود واحد فقط لا يزال قائماً',
  dest_efes_tag1: 'مدينة أثرية', dest_efes_tag2: 'روماني', dest_efes_tag3: 'يونسكو', dest_efes_tag4: 'آثار', dest_efes_tag5: 'إزمير',
  dest_efes_besttime: 'أبريل–يونيو & سبتمبر–أكتوبر',
  dest_efes_tip: 'ادخل عند الافتتاح الساعة 8 صباحاً — يصبح مكتظاً وحاراً بعد الظهر.',
  dest_kapadokya_name: 'كابادوكيا', dest_kapadokya_region: 'وسط الأناضول',
  dest_kapadokya_tagline: 'مداخن الجن والمدن تحت الأرض',
  dest_kapadokya_desc: 'إحدى أكثر المناظر الطبيعية تفرداً في العالم بمداخن جنها ومدنها تحت الأرض ورحلاتها بالمناطيد.',
  dest_kapadokya_longdesc: 'كابادوكيا المكونة من مدن مثل غوريمي وأورغوب وأوتشيسار في نفشهر، تتميز بجغرافية فريدة شكّلتها انفجارات بركانية منذ ملايين السنين. المدن الجوفية التي حفرها المسيحيون هرباً من الاضطهاد الروماني، والكنائس المنحوتة في الصخر، ومداخن الجن تجعل هذه المنطقة وجهة لا مثيل لها في العالم. التحليق فوقها بمنطاد هوائي عند الفجر هو تجربة لا تُنسى.',
  dest_kapadokya_h1_name: 'رحلة بالمنطاد', dest_kapadokya_h1_desc: 'التحليق فوق مداخن الجن عند الشروق — لا يُنسى طوال الحياة',
  dest_kapadokya_h2_name: 'مدينة ديرينكويو الجوفية', dest_kapadokya_h2_desc: 'مدينة جوفية ضخمة من 18 طابقاً لـ 20000 شخص',
  dest_kapadokya_h3_name: 'متحف غوريمي المفتوح', dest_kapadokya_h3_desc: 'كنائس صخرية مدرجة في يونسكو، مشهورة بلوحاتها الجدارية',
  dest_kapadokya_h4_name: 'قلعة أوتشيسار', dest_kapadokya_h4_desc: 'أعلى نقطة في المنطقة مع مناظر بانورامية',
  dest_kapadokya_tag1: 'منطاد', dest_kapadokya_tag2: 'يونسكو', dest_kapadokya_tag3: 'طبيعة', dest_kapadokya_tag4: 'تاريخ', dest_kapadokya_tag5: 'تصوير',
  dest_kapadokya_besttime: 'أبريل–يونيو & سبتمبر–نوفمبر',
  dest_kapadokya_tip: 'احجز رحلة المنطاد قبل يومين على الأقل — قد تُلغى حسب الأحوال الجوية.',
  dest_mardin_name: 'ماردين', dest_mardin_region: 'جنوب شرق الأناضول',
  dest_mardin_tagline: 'شعر في الحجر',
  dest_mardin_desc: 'مدينة في قلب التاريخ بمنازلها الحجرية وكنائسها السريانية وصلوتها الفريدة المطلة على سهل بلاد ما بين النهرين.',
  dest_mardin_longdesc: 'ماردين المبنية على تل يسيطر على سهل بلاد ما بين النهرين مدينة يبدو الزمن فيها واقفاً، بمنازلها المبنية من الحجر الأصفر وأزقتها الضيقة. في هذه المدينة التي يعيش فيها المسيحيون السريان منذ قرون، يأتي دير الزعفران ومدرسة قاسمية والجامع الكبير في طليعة المعالم الواجب زيارتها.',
  dest_mardin_h1_name: 'دير الزعفران', dest_mardin_h1_desc: 'دير سرياني أرثوذكسي من القرن الخامس الميلادي، لا يزال نشطاً',
  dest_mardin_h2_name: 'مدرسة قاسمية', dest_mardin_h2_desc: 'مدرسة أرتقية من القرن الـ15، أعمال حجرية رائعة',
  dest_mardin_h3_name: 'مدياط', dest_mardin_h3_desc: 'مركز حرفة الفضة التلكاري والثقافة السريانية',
  dest_mardin_h4_name: 'منظر بلاد ما بين النهرين', dest_mardin_h4_desc: 'منظر السهل اللانهائي من قمة المدينة يمتد نحو سوريا',
  dest_mardin_tag1: 'سرياني', dest_mardin_tag2: 'تاريخ', dest_mardin_tag3: 'معمار', dest_mardin_tag4: 'ثقافة', dest_mardin_tag5: 'جنوب شرق',
  dest_mardin_besttime: 'مارس–مايو & سبتمبر–نوفمبر',
  dest_mardin_tip: 'أقِم ليلة في ماردين ولا تفوّت المنظر الليلي — لوحة رائعة لا تُنسى.',
  dest_bodrum_name: 'بودروم', dest_bodrum_region: 'بحر إيجه',
  dest_bodrum_tagline: 'سان تروبيه تركيا',
  dest_bodrum_desc: 'أكثر وجهات العطل أناقة في تركيا بمنازلها المطلية بالأبيض ومرساها واليخوت وحياتها الليلية.',
  dest_bodrum_longdesc: 'بودروم في موغلا هي إحدى أكثر المنتجعات البحرية الرائجة في بحر إيجه. مع المرسى الممتد في ظل قلعة بودروم وشواطئ غومبيت الحيوية ونمط حياة الرفاهية في تركبوكو وحياة المارينا في يالي كافاك، تلبي بودروم كل الأذواق. في هذه الأرض التي تأسست فيها هاليكارناسوس القديمة، يتشابك التاريخ والحياة العصرية.',
  dest_bodrum_h1_name: 'قلعة بودروم', dest_bodrum_h1_desc: 'قلعة فرسان الإسبتارية من القرن الـ15، تحوي متحف الآثار المائية',
  dest_bodrum_h2_name: 'تركبوكو', dest_bodrum_h2_desc: 'أسلوب حياة فاخر، شواطئ خاصة ومطاعم شهيرة',
  dest_bodrum_h3_name: 'مارينا يالي كافاك', dest_bodrum_h3_desc: 'محطة شهيرة لليخوت الدولية، بوتيكات',
  dest_bodrum_h4_name: 'الرحلة الزرقاء', dest_bodrum_h4_desc: 'جولات بحرية من بودروم، خلجان ومياه كريستالية',
  dest_bodrum_tag1: 'شاطئ', dest_bodrum_tag2: 'يخت', dest_bodrum_tag3: 'حياة ليلية', dest_bodrum_tag4: 'فاخر', dest_bodrum_tag5: 'بحر إيجه',
  dest_bodrum_besttime: 'يونيو–سبتمبر',
  dest_bodrum_tip: 'ترتفع الأسعار في الموسم المرتفع (يوليو–أغسطس) — يونيو أو سبتمبر أكثر مقبولية.',
  dest_kas_name: 'كاش وكالكان', dest_kas_region: 'البحر الأبيض المتوسط',
  dest_kas_tagline: 'جواهر البحر المتوسط الهادئ',
  dest_kas_desc: 'أكثر زوايا البحر المتوسط هدوءاً وجمالاً بأسلوب عطلات بوتيك ومواقع غوص وطريق ليكيا.',
  dest_kas_longdesc: 'تقع كاش وكالكان على بعد 200 كم من أنطاليا وهي وجهات مثالية لمن يريد الهروب من المنتجعات المزدحمة. شوارع كاش الملونة والمقابر اللوكية ومواقع الغوص؛ منازل كالكان ذات التراسات والمسابح اللانهائية تجعل هذا الثنائي أكثر منتجعات تركيا رومانسية.',
  dest_kas_h1_name: 'الغوص والشنركلة', dest_kas_h1_desc: 'أحد أفضل مواقع الغوص في تركيا، مياه صافية كالكريستال',
  dest_kas_h2_name: 'مدينة كيكوفا الغارقة', dest_kas_h2_desc: 'مدينة ليكية غارقة يُشاهَد بجولة بحرية، منظر فريد',
  dest_kas_h3_name: 'طريق ليكيا', dest_kas_h3_desc: 'أشهر مسار للمشي في تركيا، 540 كم على الساحل',
  dest_kas_h4_name: 'كنيسة القديس نيقولاوس', dest_kas_h4_desc: 'في ديمره، مسقط رأس بابا نويل (القديس نيقولاوس)',
  dest_kas_tag1: 'غوص', dest_kas_tag2: 'طبيعة', dest_kas_tag3: 'رومانسي', dest_kas_tag4: 'مشي', dest_kas_tag5: 'البحر الأبيض المتوسط',
  dest_kas_besttime: 'مايو–أكتوبر',
  dest_kas_tip: 'استأجر سيارة في كاش — ضرورية لاستكشاف الخلجان والمدن الأثرية المحيطة.',
  dest_fethiye_name: 'فتحية وأولودينيز', dest_fethiye_region: 'بحر إيجه – البحر المتوسط',
  dest_fethiye_tagline: 'أسطورة البحيرة الزرقاء',
  dest_fethiye_desc: 'أكثر مناطق العطل أيقونية في تركيا بالبحيرة الزرقاء الأسطورية لأولودينيز ووادي الفراشات والباراغلايدينغ.',
  dest_fethiye_longdesc: 'تحتضن فتحية في موغلا أجمل الخلجان في تركيا. البحيرة الفيروزية لأولودينيز هي إحدى أكثر الشواطئ تصويراً في العالم. الباراغلايدينغ من جبل بابا داغ وجمال وادي الفراشات المعزول والمياه الباردة لوادي صاكلي كنت تجعل فتحية وجهة يمكن زيارتها في كل مواسم السنة.',
  dest_fethiye_h1_name: 'بحيرة أولودينيز', dest_fethiye_h1_desc: 'إحدى أجمل الشواطئ في العالم، بحيرة فيروزية',
  dest_fethiye_h2_name: 'الباراغلايدينغ', dest_fethiye_h2_desc: 'نزول من ارتفاع 1960م من جبل بابا داغ نحو أولودينيز',
  dest_fethiye_h3_name: 'وادي الفراشات', dest_fethiye_h3_desc: 'خليج جنة معزول يمكن الوصول إليه فقط بالقارب',
  dest_fethiye_h4_name: 'وادي صاكلي كنت', dest_fethiye_h4_desc: 'أطول وادٍ في تركيا، مشي في مياه باردة',
  dest_fethiye_tag1: 'بحيرة', dest_fethiye_tag2: 'باراغلايدينغ', dest_fethiye_tag3: 'شاطئ', dest_fethiye_tag4: 'طبيعة', dest_fethiye_tag5: 'رحلة زرقاء',
  dest_fethiye_besttime: 'مايو–أكتوبر',
  dest_fethiye_tip: 'للباراغلايدينغ، فضّل ساعات الصباح الباكر — الرياح أهدأ.',
  dest_cesme_name: 'تشيشمه وألاتشاتي', dest_cesme_region: 'بحر إيجه',
  dest_cesme_tagline: 'عاصمة الرياح والتزلج على الأمواج',
  dest_cesme_desc: 'أكثر منطقة منتجع أناقة في بحر إيجه بمنازل ألاتشاتي الحجرية والتزلج على الأمواج ومياه تشيشمه الصافية.',
  dest_cesme_longdesc: 'شبه جزيرة تشيشمه على بعد 80 كم من إزمير تجمع بين فنادق ألاتشاتي البوتيك والتزلج على الأمواج مع بحر تشيشمه الصافي وحياتها الليلية. التجول في أزقة ألاتشاتي الحجرية الضيقة بين المنازل المزينة بالزهور والمقاهي والبوتيكات هو تجربة بحد ذاتها.',
  dest_cesme_h1_name: 'التزلج على الأمواج', dest_cesme_h1_desc: 'خليج ألاتشاتي، مضيف بطولة العالم للتزلج على الأمواج',
  dest_cesme_h2_name: 'سوق ألاتشاتي', dest_cesme_h2_desc: 'منازل حجرية، بوتيكات، مقاهٍ ومطاعم',
  dest_cesme_h3_name: 'شواطئ تشيشمه', dest_cesme_h3_desc: 'ألتن قوم وإيليجا وبوياليك — مياه صافية كالكريستال',
  dest_cesme_h4_name: 'قلعة تشيشمه', dest_cesme_h4_desc: 'قلعة جنوية مع متحف للآثار',
  dest_cesme_tag1: 'تزلج', dest_cesme_tag2: 'بوتيك', dest_cesme_tag3: 'شاطئ', dest_cesme_tag4: 'بحر إيجه', dest_cesme_tag5: 'طعام',
  dest_cesme_besttime: 'يونيو–سبتمبر',
  dest_cesme_tip: 'لا تفوّت سوق الأحد العضوي في ألاتشاتي.',
  dest_pamukkale_name: 'باموكالي', dest_pamukkale_region: 'بحر إيجه',
  dest_pamukkale_tagline: 'قلعة القطن، الجنة البيضاء',
  dest_pamukkale_desc: 'أعجوبة طبيعية فريدة ابتكرتها الطبيعة بتراسيناتها البيضاء وآثار هيرابوليس القديمة.',
  dest_pamukkale_longdesc: 'باموكالي في دنيزلي أعجوبة طبيعية مغطاة بتراسيناتها البيضاء التي تشكّلت على مدى آلاف السنين من خلال المياه الحرارية المحتوية على كربونات الكالسيوم. كانت مدينة هيرابوليس القديمة في قمتها مركزاً صحياً مهماً في الحقبة الرومانية. اليوم يمكن للزوار السباحة في البركة القديمة والمشي على التراسيناتها. هذا الموقع المدرج في التراث العالمي لليونسكو هو أحد أكثر المناطق الطبيعية زيارة في تركيا.',
  dest_pamukkale_h1_name: 'التراسينات', dest_pamukkale_h1_desc: 'مدرجات الحجر الجيري الأبيض، المياه الحرارية والبرك الطبيعية',
  dest_pamukkale_h2_name: 'هيرابوليس', dest_pamukkale_h2_desc: 'مدينة أثرية من الحقبة الرومانية، مسرح وأرض الأموات',
  dest_pamukkale_h3_name: 'البركة القديمة', dest_pamukkale_h3_desc: 'حمام حراري يُقال إن كليوباترا كانت تسبح فيه، بين أعمدة أثرية',
  dest_pamukkale_h4_name: 'لاودكية', dest_pamukkale_h4_desc: 'مدينة أثرية من حقبة المسيحية المبكرة في المجاورة',
  dest_pamukkale_tag1: 'طبيعة', dest_pamukkale_tag2: 'حراري', dest_pamukkale_tag3: 'يونسكو', dest_pamukkale_tag4: 'مدينة أثرية', dest_pamukkale_tag5: 'تصوير',
  dest_pamukkale_besttime: 'أبريل–يونيو & سبتمبر–نوفمبر',
  dest_pamukkale_tip: 'يجب خلع حذائك للمشي على التراسينات — أحضر جوارب.',
  dest_karadeniz_name: 'البحر الأسود وطرابزون', dest_karadeniz_region: 'البحر الأسود',
  dest_karadeniz_tagline: 'ألف درجة من الأخضر',
  dest_karadeniz_desc: 'الجمال الغامض للبحر الأسود مع دير سوميلا وبحيرة أوزون غول والمرتفعات الخضراء.',
  dest_karadeniz_longdesc: 'منطقة البحر الأسود في شمال تركيا تقدم تركيا مختلفة تماماً بغاباتها الكثيفة الخضراء ومرتفعاتها المكتنفة بالضباب ومبانيها التاريخية. مركز طرابزون وعظمة دير سوميلا المنحوت في الجروف وبحيرة أوزون غول الخرافية والمياه الحرارية لمرتفع أيدر تجعل هذه المنطقة صالحة للزيارة في جميع الفصول الأربعة.',
  dest_karadeniz_h1_name: 'دير سوميلا', dest_karadeniz_h1_desc: 'دير بيزنطي من عام 386م، منحوت في جروف شاهقة',
  dest_karadeniz_h2_name: 'أوزون غول', dest_karadeniz_h2_desc: 'بحيرة جبلية خرافية محاطة بالضباب والغابات',
  dest_karadeniz_h3_name: 'مرتفع أيدر', dest_karadeniz_h3_desc: 'مرتفع مشهور بمياهه الحرارية وثقافة المرتفعات',
  dest_karadeniz_h4_name: 'آيا صوفيا طرابزون', dest_karadeniz_h4_desc: 'كنيسة بيزنطية من القرن الـ13 بلوحاتها الجدارية الأصلية',
  dest_karadeniz_tag1: 'طبيعة', dest_karadeniz_tag2: 'مرتفع', dest_karadeniz_tag3: 'بيزنطي', dest_karadeniz_tag4: 'حراري', dest_karadeniz_tag5: 'تصوير',
  dest_karadeniz_besttime: 'مايو–سبتمبر',
  dest_karadeniz_tip: 'اذهب إلى دير سوميلا في الصباح الباكر — التقط الأجواء الغامضة قبل أن يتبدد الضباب.',
  dest_safranbolu_name: 'صافرانبولو', dest_safranbolu_region: 'غرب البحر الأسود',
  dest_safranbolu_tagline: 'متجمد في الزمن العثماني',
  dest_safranbolu_desc: 'مدينة توقف فيها الزمن، بقصورها العثمانية المدرجة في التراث العالمي لليونسكو.',
  dest_safranbolu_longdesc: 'صافرانبولو في قرابوك هي إحدى أفضل المدن التاريخية المحفوظة في تركيا بأكثر من 1000 قصر عثماني يعود تاريخها إلى القرنين الـ18 والـ19. بأزقتها الحجرية الضيقة ومنازلها الخشبية ذات الشرفات البارزة وسوقها التاريخي، تبدو صافرانبولو كمتحف مفتوح. في هذه المدينة المدرجة في التراث العالمي لليونسكو، تحتل حدائق الزعفران والراحات ذات الشهرة والحرف اليدوية المحلية مكانة مهمة أيضاً.',
  dest_safranbolu_h1_name: 'القصور العثمانية', dest_safranbolu_h1_desc: 'أكثر من 1000 قصر تاريخي، كثير منها تحول إلى فنادق بوتيك',
  dest_safranbolu_h2_name: 'السوق التاريخي', dest_safranbolu_h2_desc: 'سوق من الحقبة العثمانية، صنّاع النحاس وصانعو الراحة',
  dest_safranbolu_h3_name: 'قرية يوروك', dest_safranbolu_h3_desc: 'قرية تقليدية توقف فيها الزمن',
  dest_safranbolu_h4_name: 'وادي توكاتلي', dest_safranbolu_h4_desc: 'وادٍ طبيعي قريب من المدينة، مثالي للمشي',
  dest_safranbolu_tag1: 'يونسكو', dest_safranbolu_tag2: 'عثماني', dest_safranbolu_tag3: 'معمار', dest_safranbolu_tag4: 'ثقافة', dest_safranbolu_tag5: 'طبيعة',
  dest_safranbolu_besttime: 'أبريل–نوفمبر',
  dest_safranbolu_tip: 'أقِم في قصر عثماني — النوم في التاريخ لا يقدر بثمن.',
};

export default pages;
